<template>
<div class="chapter">
<div class="inner_page">
<p class="fm_title"><a id="page_v">Contents</a></p><a id="page_v">
</a><p class="toc"><a id="page_v"></a><a href="#/06_ack">Acknowledgments</a></p>
<p class="toc1"><a href="#/07_signal">Sigla</a></p>
<p class="toc"><a href="#/09_intro">Introduction: Philosophy and Edification</a></p>
<p class="toc2"><span href="#/10_part1" title="Link target outside of Sample"><b>Part I. Jest and/or Earnestness</b></span></p>
<p class="toc3"><span href="#/11_chap1" title="Link target outside of Sample"><b>1</b>   Blunt Reading</span></p>
<p class="toc3"><span href="#/12_chap2" title="Link target outside of Sample"><b>2</b>   Alternatives to Différance</span></p>
<p class="toc3"><span href="#/13_chap3" title="Link target outside of Sample"><b>3</b>   Communicating Capability</span></p>
<p class="toc2"><span href="#/14_part2" title="Link target outside of Sample"><b>Part II. Suspicion or Trust</b></span></p>
<p class="toc3"><span href="#/15_chap4" title="Link target outside of Sample"><b>4</b>   Deconstructing <i>The Point of View</i></span></p>
<p class="toc3"><span href="#/16_chap5" title="Link target outside of Sample"><b>5</b>   Trusting <i>The Point of View</i></span></p>
<p class="toc2"><span href="#/17_part3" title="Link target outside of Sample"><b>Part III. Faith and Virtue</b></span></p>
<p class="toc3"><span href="#/18_chap6" title="Link target outside of Sample"><b>6</b>   The Pseudonymous Dialectic of Faith, I</span></p>
<p class="toc3"><span href="#/19_chap7" title="Link target outside of Sample"><b>7</b>   The Pseudonymous Dialectic of Faith, II</span></p>
<p class="toc1"><span href="#/20_concl" title="Link target outside of Sample">Conclusions: Kierkegaard, Virtue, and Edification</span></p>
<p class="toc"><span href="#/21_note" title="Link target outside of Sample">Notes</span></p>
<p class="toc1"><span href="#/22_index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_content.vue?313639ac